<template>
    <div>
        <span v-html="$t('notification.taskWorkflowPermanentlyDeleted', {user: $_.get(activity, 'actorUser.name'), workflow: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskWorkflowPermanentlyDeleted",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

